import { ToolGroupEntry } from '../../extensions/tool-extension';

export type CollapsedToolEntry = {
  entry: ToolGroupEntry;
  count: number;
};

export const collapseConsecutiveTools = (
  entries: ToolGroupEntry[],
): CollapsedToolEntry[] => {
  if (entries.length === 0) return [];

  const result: CollapsedToolEntry[] = [];
  let current: CollapsedToolEntry = { entry: entries[0], count: 1 };

  for (let i = 1; i < entries.length; i++) {
    if (entries[i].tool === current.entry.tool) {
      current = { ...current, count: current.count + 1 };
    } else {
      result.push(current);
      current = { entry: entries[i], count: 1 };
    }
  }

  result.push(current);
  return result;
};
